import { useTranslation } from 'react-i18next';

export const APIPage = () => {
  const { t } = useTranslation('authenticated.settings');

  return (
    <div className="p-4">
      <p className="text-sm text-muted-foreground">{t('pages.api.placeholder')}</p>
    </div>
  );
};
